import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";

import { CustomPanel, CustomPanelSizeType } from "Components/Generic/CustomPanel";
import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";
import { isNotEmpty } from "Utils/Object";
import { Entry } from "./Entry";
import { useManageIgnoredSourceDataStyles } from "./UseManageIgnoredSourceDataStyles";
import { useManageIgnoredSourceData } from "./UseManageIgnoredSourceData";

export const ManageIgnoredSourceData = WithTranslator(({ translator }: IWithTranslatorProps): JSX.Element => {
  const { showDialog, ignoredSourceData, onDismiss } = useManageIgnoredSourceData();
  const hasIgnoredValues = isNotEmpty(ignoredSourceData);
  const styles = useManageIgnoredSourceDataStyles();

  return (
    <CustomPanel
      isOpen={showDialog}
      onDismiss={onDismiss}
      customPanelSize={CustomPanelSizeType.small}
      headerTitle={translator.get(`staging.ignored.title`, `Manage ignored source data`)}
      isLightDismiss
    >
      <Stack className={styles.root}>
        {hasIgnoredValues
          ? (
            Object.entries(ignoredSourceData)
              .filter(([fieldName]) => !fieldName.startsWith(`@`) && ![`companies`].includes(fieldName))
              .map(([fieldName]) => (
                <Stack.Item key={fieldName}>
                  <Entry fieldName={fieldName} item={ignoredSourceData} />
                </Stack.Item>
              ))
          )
          : (
            <Text>{translator.get(`generic.noresults`, `No results found`)}</Text>
          )}
      </Stack>
    </CustomPanel>
  );
});
